// Shared display constants + helpers for the governed Sentinels area.

export const SEV_STYLE = {
  critical: 'bg-rose-500/15 border-rose-500/40 text-rose-600 dark:text-rose-300',
  high: 'bg-orange-500/15 border-orange-500/40 text-orange-600 dark:text-orange-300',
  medium: 'bg-amber-500/15 border-amber-500/30 text-amber-600 dark:text-amber-300',
  low: 'bg-muted/40 border-border/40 text-muted-foreground',
};

export const STATUS_STYLE = {
  draft: 'bg-muted/50 border-border/50 text-muted-foreground',
  pending_approval: 'bg-sky-500/10 border-sky-500/30 text-sky-600 dark:text-sky-300',
  active: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-600 dark:text-emerald-300',
  paused: 'bg-amber-500/10 border-amber-500/30 text-amber-600 dark:text-amber-300',
  degraded: 'bg-orange-500/10 border-orange-500/40 text-orange-600 dark:text-orange-300',
  retired: 'bg-muted/40 border-border/40 text-muted-foreground line-through',
};

export const INCIDENT_STATUS_STYLE = {
  open: 'bg-rose-500/10 border-rose-500/30 text-rose-600 dark:text-rose-300',
  acknowledged: 'bg-sky-500/10 border-sky-500/30 text-sky-600 dark:text-sky-300',
  assigned: 'bg-violet-500/10 border-violet-500/30 text-violet-600 dark:text-violet-300',
  resolved: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-600 dark:text-emerald-300',
  recovery_verified: 'bg-emerald-600/15 border-emerald-600/40 text-emerald-700 dark:text-emerald-300',
};

export const HEALTH_STYLE = {
  healthy: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-600 dark:text-emerald-300',
  warning: 'bg-amber-500/10 border-amber-500/30 text-amber-600 dark:text-amber-300',
  critical: 'bg-rose-500/10 border-rose-500/40 text-rose-600 dark:text-rose-300',
};

export const PURPOSE_LABEL = {
  risk: 'Risk', opportunity: 'Opportunity', goal: 'Goal',
  compliance: 'Compliance', data_quality: 'Data quality', operational: 'Operational',
};

export const STATUS_LABEL = {
  draft: 'Draft', pending_approval: 'Pending approval', active: 'Active',
  paused: 'Paused', degraded: 'Degraded', retired: 'Retired',
};

export const INCIDENT_STATUS_LABEL = {
  open: 'Open', acknowledged: 'Acknowledged', assigned: 'Assigned',
  resolved: 'Resolved', recovery_verified: 'Recovery verified',
};

export const OPERATOR_LABEL = { gt: 'above (>)', gte: 'at or above (≥)', lt: 'below (<)', lte: 'at or below (≤)' };
export const DIRECTION_LABEL = { up: 'up', down: 'down', any: 'either way' };

export function labelize(s) {
  return String(s || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function fmtNum(v) {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  if (Math.abs(n) >= 1000) return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
  if (Math.abs(n) >= 1) return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
  return n.toFixed(4);
}

export function timeAgo(iso) {
  if (!iso) return 'never';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export const sid = (s) => String(s || '').replace(/[^a-z0-9]/gi, '-');
